import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  heading: {
    fontSize: UNIT * 0.9375,
    fontWeight: 'bolder',
    minWidth: UNIT * 12.5,
    color: mainColor.colorBlackLight
  },
  lastHeading: {
    fontSize: UNIT * 0.9375,
    padding: UNIT * 0.5625,
    fontWeight: 'bolder',
    color: mainColor.colorBlackLight
  },
  valueC: {
    fontSize: UNIT * 0.9375,
    flexBasis: '19%',
    flexShrink: 0,
    padding: UNIT * 1.0625,
    textAlign: 'center',
    color: 'black !important'
  },
  arrow: {
    padding: '3px 0px 0px 0px'
  },
  table: {
    minWidth: UNIT * 12.5
  },
  progress: {
    margin: UNIT * 7.5
  },
  iconButton: {
    position: 'relative',
    right: UNIT * 0.4375
  },
  circularProgress: {
    textAlign: 'center',
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
  },
  button: {
    padding: '0px 12px'
  },
  right: {
    paddingRight: '5px'
  }
});
